// extracted by mini-css-extract-plugin
module.exports = {"expandable":"Expandable_expandable__bngfd","expandableWrapper":"Expandable_expandableWrapper__s_bcj"};